var _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSuccessfulCircle = function SvgSuccessfulCircle(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "checkmark-circle",
    d: "M155.068,1161.675a2.5,2.5,0,0,0-3.415.9l-15.987,27.7-8.945-8.25a2.5,2.5,0,0,0-3.65,3.425L134.5,1196a2.5,2.5,0,0,0,3.533.1c.3-.275,17.95-31.025,17.95-31.025a2.485,2.485,0,0,0-.915-3.4ZM140,1214a35,35,0,1,1,35-35,35,35,0,0,1-35,35Zm0-75a40,40,0,1,0,40,40,40,40,0,0,0-40-40Z",
    transform: "translate(-100 -1139)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessfulCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/successful-circle.08e063f1.svg";
export { ForwardRef as ReactComponent };